import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const SettingsContext = createContext(null);

const API_URL = process.env.REACT_APP_BACKEND_URL;

const defaultSettings = {
  school_name: "SchoolAV Inventory",
  logo_url: "https://customer-assets.emergentagent.com/job_av-asset-hub/artifacts/ec7vtf0g_IMG_0542.png",
  accent_color: "#2563EB",
  default_theme: "dark"
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(defaultSettings);
  const [loading, setLoading] = useState(true);

  const fetchSettings = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/api/settings`);
      setSettings(response.data);
    } catch (error) {
      console.error('Failed to fetch settings:', error);
      setSettings(defaultSettings);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  const updateSettings = async (newSettings, token) => {
    try {
      const response = await axios.put(`${API_URL}/api/settings`, newSettings, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSettings(response.data);
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  return (
    <SettingsContext.Provider value={{ settings, loading, updateSettings, refreshSettings: fetchSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within SettingsProvider');
  }
  return context;
};
